<!--
    
    # slide-out

    This component is the slide-out / detail panel that is used throughout Apollo.

    ## Slots

    - front: The front of the panel.
    - back: The back of the panel.

    ## Methods

    - open: Opens the panel.
    - close(fireEvent): Closes the panel; will also flip the panel to the front side. Fires the `close` event if specified.
    - flip: Flips the panel.

    ## Events

    - close: Fired when the panel is closed (usually manually, but caller can force event to fire).
-->
<template>
    <div class="detail-panel flip-container" :class="{ open: isOpen, flipped: isFlipped }">
        <div class="flipper" :class="{ immediate: isImmediate }">
            <div class="front">
                <div class="columns">
                    <div class="column">
                        <a class="delete is-pulled-right" @click="close(true)"></a>
                        <slot name="front"></slot>
                    </div>
                </div>
            </div>

            <div class="back">
                <div class="columns">
                    <div class="column">
                        <a class="delete is-pulled-right" @click="close(true)"></a>
                        <slot name="back"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "slide-out",
    props: {
        flippable: {
            type: [Boolean],
            default: false
        },
        showDefault: {
            type: [Boolean],
            default: false
        },
        canclose: {
            type: Function,
            default: function(){
                return true;
            }
        }
    },
        filters: {
            currency: function (value) {
                return '$' + parseFloat(value).toFixed(2);
            }
        },
    methods: {
        open: function () {
            this.isOpen = true;
            this.$emit("open");

            var me = this;
            setTimeout(function () {
                me.isImmediate = false;
            }, 500);
        },
        close: function (fireEvent) {
            if(this.canclose()){
                this.isOpen = false;

                var me = this;
                setTimeout(function () {
                    me.isFlipped = false;
                    me.isImmediate = true;
                }, 500);

                if (fireEvent) {
                    this.$emit("close");
                }
            }
        },
        flip: function () {
            this.isFlipped = !this.isFlipped;
            this.$emit("flip");
        },
    },
    data: function () {
        return {
            isOpen: false,
            isFlipped: false,
            isImmediate: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// SlideOut.vue?55123dae